module.exports = __webpack_public_path__ + "static/img/ycscsd.f63e197.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ycscsd.png
// module id = 7Myp
// module chunks = 0